import React from 'react';

import Icon, { Props } from '../icon';

export const SuccessIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40" fill="none">
      <path
        d="M20.0004 0C8.97516 0 0 8.99801 0 20.0513C1.10002 46.6568 38.9007 46.6443 40.0007 20.0513C40.0007 8.99801 31.0256 0 20.0004 0Z"
        fill="#00C9A2"
      />
      <path
        d="M28.4265 11.0891C28.7773 10.5928 29.4621 10.4758 29.9557 10.8284C30.4491 11.1812 30.5652 11.8701 30.2148 12.3665L18.5247 28.9114C18.3377 29.176 18.0433 29.3442 17.7216 29.3713C17.4002 29.3982 17.0833 29.2819 16.8553 29.0525L9.90458 22.0521C9.47666 21.6212 9.47627 20.923 9.90458 20.4925C10.333 20.0621 11.0272 20.0628 11.4551 20.4935L17.4881 26.5686L28.4265 11.0891Z"
        fill="#F2F2F2"
      />
    </Icon>
  );
};

export default SuccessIcon;
